import { useCurrentInstance } from '@/api/organization';
import { InstanceNavigate } from '@/components/routing';

import { DEFAULT_APP_PATH, DEFAULT_ONBOARDING_PATH } from './routes';

const DefaultAppRedirect = () => {
  const { instance } = useCurrentInstance();

  if (!instance?.tagInstallationDate) {
    return <InstanceNavigate to={DEFAULT_ONBOARDING_PATH} replace />;
  }

  return <InstanceNavigate to={DEFAULT_APP_PATH} replace />;
};

export default DefaultAppRedirect;
